import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FDBox, FDStack } from '@facet-wealth/design';
import Disclaimer from './Disclaimer';

const Disclaimers = ({ collection }) => {
  // Determine the index to expand
  const resources = collection.resources().list();
  const seenUnaccepted = false;
  let expandedId = '';
  for (let i = 0; i < resources.length; i++) {
    const resource = resources[i];
    if (!seenUnaccepted && resource.attr('accepted') === 'false') {
      expandedId = resource.id();
      break;
    }
  }
  const [acceptedDisclaimers, setAcceptedDisclaimers] = useState([]);

  useEffect(() => {
    expandedId = '';
  }, [acceptedDisclaimers.length]);

  return (
    <FDStack direction={'column'} spacing={4}>
      {resources.map((resource) => {
        return (
          <FDBox key={resource.id()} flex={1}>
            <Disclaimer
              resource={resource}
              onAccept={(id) => {
                setAcceptedDisclaimers([...acceptedDisclaimers, id]);
              }}
              expandedId={expandedId}
            />
          </FDBox>
        );
      })}
    </FDStack>
  );
};

Disclaimers.propTypes = {
  collection: PropTypes.object.isRequired,
};

Disclaimers.defaultProps = {};

export default Disclaimers;
